/** Shared by every log line in this feature, so the whole thing is greppable as one. */
export const LOG_PREFIX = '[Launch Darkly]';

/**
 * One environment value, normalised, with empty treated as absent.
 *
 * Empty-means-absent is stack-control's own contract, not a convenience: an
 * empty value means "no Dev Server", never "a Dev Server at the empty address",
 * and "absent" has to mean one thing on both sides of that contract - and the
 * same thing on the browser-config side of this feature too.
 */
export function readEnv(value: string | undefined): string {
  return value?.trim() ?? '';
}
